export default __webpack_public_path__ + "static/international-yards-desktop-4f941ddc8a578946cb80f94ab06bf063.svg";